module.exports = __webpack_public_path__ + "img/gifiqr-om-os.ae6bbb25.jpg";